import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TRANSLOCO_SCOPE, TranslocoModule } from '@ngneat/transloco';
import { ComponentsModule } from '../../../components/components.module';
import { CatalogRedirectComponent } from './catalog-redirect.component';
import { ReactiveFormsModule } from '@angular/forms';
import { PipesModule } from '../../../pipes/pipes.module';
import { DirectivesModule } from '../../../directives/directives.module';
import { CarouselModule } from 'ngx-owl-carousel-o';
import { CloudinaryModule } from '@cloudinary/ng';
import { LocalizeUrlPathModule } from '@lobos/library';
import { RouterModule } from '@angular/router';
import { NgWherePipeModule } from 'angular-pipes';
import { AccessoryListComponent } from './accessory-list/accessory-list.component';
import { ArticleAccessoriesModalComponent } from './article-accessories-modal/article-accessories-modal.component';
import { ActiveFilterListComponent } from './active-filter-list/active-filter-list.component';
import { FacetItemComponent } from './facet-item/facet-item.component';
import { FacetOptionComponent } from './facet-item/facet-option/facet-option.component';
import { ImageGalleryComponent } from './image-gallery/image-gallery.component';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';

const components: any[] = [
  CatalogRedirectComponent,
  AccessoryListComponent,
  ArticleAccessoriesModalComponent,
  ActiveFilterListComponent,
  FacetItemComponent,
  FacetOptionComponent,
  ImageGalleryComponent,
];

@NgModule({
  declarations: components,
  imports: [
    CommonModule,
    TranslocoModule,
    ComponentsModule,
    ReactiveFormsModule,
    PipesModule,
    DirectivesModule,
    CarouselModule,
    CloudinaryModule,
    LocalizeUrlPathModule,
    RouterModule,
    NgWherePipeModule,
    MatFormFieldModule,
    MatSelectModule,
  ],
  exports: components,
  providers: [{ provide: TRANSLOCO_SCOPE, useValue: 'catalog' }],
})
export class CatalogComponentsModule {}
